<div class="bgCard" >
    <div class="dilogStl">
        <h1 style="
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 33px;" mat-dialog-title>Attendance Report</h1>
           <button align="end" mat-icon-button mat-dialog-close >
            <mat-icon style="color:#0038FF" svgIcon="feather:x"></mat-icon>       
          </button>
    </div>
    <mat-dialog-content class="mat-typography" >
        <div class="card dataCard">
            <div class="col-12 row" [formGroup]="dateDetailsForm">
                <div class="col-sm-12 col-md-12 col-lg-6">
                    <div class="fw-bold fieldName">
                        From Date
                        <span class="text-danger">*</span>
                    </div>
                    <div class="">
                        <mat-form-field class="flex-auto gt-xs:pr-3 w-full">
                            <input matInput readonly [matDatepicker]="picker" [placeholder]="'From Date'" formControlName="fromDate" (dateChange)="addEvent($event)"
                                 [max]="maxDate">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-6">
                    <div class="fw-bold fieldName">
                        To Date
                        <span class="text-danger">*</span>
                    </div>
                    <div class="">
                    
                        <mat-form-field class="flex-auto gt-xs:pr-3 w-full" style="width: 90%;">
                            <input matInput readonly [matDatepicker]="picker1" formControlName="toDate" (dateChange)="addEvent($event)"
                                [placeholder]="'To Date'" [max]="maxDate" [min]="minDate">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>

                    </div>
                </div>
            </div>
            <div class="col-12 row"  >
                <div class=" col-sm-12 col-md-12 col-lg-4">
                    <div class="fw-bold fieldName">
                        Branch
                    </div>
                    <div class="" >
                        <mat-form-field class="flex-auto gt-xs:pr-3 w-full"  >
                          <mat-select [placeholder]="'All Branches'"  [(ngModel)]="checked_branches_list" (ngModelChange)="getUsers()" multiple>
                            <mat-checkbox class="" [checked]="allBranchesChecked" [indeterminate]="someBranchesChecked()" (change)="setAllBranchesChecked($event)">
                                Select All
                            </mat-checkbox>
                            <mat-option *ngFor="let branch of branchesList" [value]="branch.id">{{branch.name | titlecase  }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                       
                      </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-4">
                    <div class="fw-bold fieldName">
                       Role
                    </div>
                    <div class="" >
                        <mat-form-field class="flex-auto gt-xs:pr-3 w-full"  >
                          <mat-select [placeholder]="'All Roles'"  [(ngModel)]="checked_roles_list" (ngModelChange)="getUsers()" multiple>
                            <mat-checkbox class="" [checked]="allRolesChecked" [indeterminate]="someRolesChecked()" (change)="setAllRolesChecked($event)">
                                Select All
                            </mat-checkbox>
                            <mat-option *ngFor="let role of roleList" [value]="role.id">{{role.name | titlecase }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-4">
                    <div class="fw-bold fieldName">
                        User
                    </div>
                    <div class="" >
                        <mat-form-field class="flex-auto gt-xs:pr-3 w-full" >
                          <mat-select [placeholder]="'All Users'" [(ngModel)]="checked_users_list" multiple >
                            <mat-checkbox class="" [checked]="allUsersChecked" [indeterminate]="someUsersChecked()" (change)="setAllUsersChecked($event)">
                                Select All
                            </mat-checkbox>
                            <mat-option *ngFor="let user of userList" [value]="user.id">{{user.full_name | titlecase }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                </div>
            </div>
            <div class=" mt-8 mb-4 d-flex justify-content-center">
                <!-- <a
                class="ml-4 addBtn"
                mat-flat-button
                [color]="'primary'"
                >
               
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2 mr-1 txt">Create Branch</span>
            </a> -->
            <div class="">
                <button class="ml-4 addBtn" [ngClass]="{'btn-clr': dateDetailsForm.valid}" mat-flat-button [color]="'primary'" [disabled]="!dateDetailsForm.valid" (click)="downloadReport()" >
                    <mat-icon class="white-icon" [svgIcon]="'mat_outline:file_download'"></mat-icon>
                  <span class="ml-2 mr-1 txt" style="color: black">Download</span>
                </button>
              </div>
            </div>
        </div>
        </mat-dialog-content>
</div>

